/* eslint-disable */ import { ConfiguratorBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { adminGeneratedComponents } from './admin-components/index.js';
import * as AdminEnhancenModel from './admin-enhanced-model.js';
import { attachAdminComponent, createAdminRecipe, implementAdminCustomExpressions, implementCustomAdminInvariants } from './admin-implementation.js';
import * as AdminModel from './admin-model/index.js';
import { generatedAdminPresets } from './admin-presets.js';
import { $dataSpec, AdminNavigationState, AdminViewState, ApplicationVersion, CallbackData, ExportState, FinalizeData, FinalizeResult, NavigationState, PrefetchedFinalizeData, ToolState, ViewState } from './application-types.js';
import * as ApplicationTypes from './application-types.js';
import { generatedComponents } from './components/index.js';
import * as EnhancedModel from './enhanced-model.js';
import { attachComponent, createRecipe, implementCustomExpressions, implementCustomInvariants } from './implementation.js';
import * as Model from './model/index.js';
import { generatedPresets } from './presets.js';
export const generatedConfiguratorBuilder = new ConfiguratorBuilder({
    componentOptics: generatedComponents,
    adminComponentOptics: adminGeneratedComponents
}).withPrefetchedFinalizeData(PrefetchedFinalizeData).withFinalizeData(FinalizeData).withFinalizeResult(FinalizeResult).withNavigationState(NavigationState).withViewState(ViewState).withToolState(ToolState).withExportState(ExportState).withCallbackData(CallbackData).withAdminNavigationState(AdminNavigationState).withAdminViewState(AdminViewState).withDataSpec($dataSpec).withVersion(ApplicationVersion).withPresets(generatedPresets).withAdminPresets(generatedAdminPresets).withResourcesConfig({
    prefetchTextureUrls: [
        '/swatches/solid.png',
        '/swatches/polka-dot.png',
        '/textures/Polkadot/AQUA_DOT_1_IN_8.10.png',
        '/textures/Polkadot/BLACK_DOT_1_IN_8.10.png',
        '/textures/Polkadot/FUCHSIA_DOT_1_IN_8.10.png',
        '/textures/Polkadot/LTGREY_DOT_1_IN_8.10.png',
        '/textures/Polkadot/NAVY_DOT_1_IN_8.10.png',
        '/textures/Polkadot/PURPLE_DOT_1_IN_8.10.png',
        '/textures/Polkadot/RED_DOT_1_IN_8.10.png',
        '/textures/Polkadot/ROYALBLUE_DOT_1_IN_8.10.png',
        '/swatches/stripe-mini.png',
        '/textures/MiniStripe/BLACK_WHITE_MINI_STRIPE_REPEAT.jpg',
        '/textures/MiniStripe/LAVENDER_WHITE_MINI_STRIPE_REPEAT.jpg',
        '/textures/MiniStripe/LTBLUE_WHITE_MINI_STRIPE_REPEAT.jpg',
        '/textures/MiniStripe/LTGRAY_WHITE_MINI_STRIPE_REPEAT.jpg',
        '/textures/MiniStripe/RED_WHITE_MINI_STRIPE_REPEAT.jpg',
        '/textures/MiniStripe/ROYAL_WHITE_MINI_STRIPE_REPEAT.jpg',
        '/textures/MiniStripe/TEAL_WHITE_MINI_STRIPE_REPEAT.jpg',
        '/swatches/stripe-medium.png',
        '/textures/MediumStripe/BLACK_MONTEREY_STRIPE_REPEAT.jpg',
        '/textures/MediumStripe/JUNGLEGREEN_MONTEREY_STRIPE_REPEAT.jpg',
        '/textures/MediumStripe/LTBLUE_MONTEREY_STRIPE_REPEAT.jpg',
        '/textures/MediumStripe/LTGRAY_MONTEREY_STRIPE_REPEAT.jpg',
        '/textures/MediumStripe/PINK_MONTEREY_STRIPE_REPEAT.jpg',
        '/textures/MediumStripe/PURPLE_MONTEREY_STRIPE_REPEAT.jpg',
        '/textures/MediumStripe/RED_MONTEREY_STRIPE_REPEAT.jpg',
        '/swatches/stripe-bold.png',
        '/textures/BoldStripe/AQUA_BAHA_STRIPE_REPEAT.jpg',
        '/textures/BoldStripe/BLACK_BAHA_STRIPE_REPEAT.jpg',
        '/textures/BoldStripe/BLUE_BAHA_STRIPE_REPEAT.jpg',
        '/textures/BoldStripe/LTBLUE_BAHA_STRIPE_REPEAT.jpg',
        '/textures/BoldStripe/LTGRAY_BAHA_STRIPE_REPEAT.jpg',
        '/textures/BoldStripe/LTPINK_BAHA_STRIPE_REPEAT.jpg',
        '/textures/BoldStripe/NAVY_BAHA_STRIPE_REPEAT.jpg',
        '/textures/BoldStripe/PURPLE_BAHA_STRIPE_REPEAT.jpg',
        '/textures/BoldStripe/RED_BAHA_STRIPE_REPEAT.jpg',
        '/swatches/ginghams.png',
        '/textures/Gingham/LAVENDER_GINGHAM_REPEAT.jpg',
        '/textures/Gingham/NAVY_GINGHAM_REPEAT.jpg',
        '/textures/Gingham/PINK_GINGHAM_REPEAT.jpg',
        '/textures/Gingham/RED_GINGHAM_REPEAT.jpg',
        '/textures/Gingham/SEAFOAM_GINGHAM_REPEAT.jpg',
        '/textures/Gingham/SKYBLUE_GINGHAM_REPEAT.jpg'
    ]
});
export * as AdminEnhancedModel from './admin-enhanced-model.js';
export * as AdminModel from './admin-model/index.js';
export * as ApplicationTypes from './application-types.js';
export * as EnhancedModel from './enhanced-model.js';
export * as Model from './model/index.js';
// @ts-ignore - Initialize the globals
if (!globalThis.phx) {
    // @ts-ignore - Initialize the globals
    globalThis.phx = {};
}
// @ts-ignore - Initialize the globals
globalThis.phx.applicationTypes = ApplicationTypes;
// @ts-ignore - Initialize the globals
globalThis.phx.domain = {
    model: Model,
    enhancedModel: EnhancedModel,
    implementCustomInvariants: implementCustomInvariants,
    implementCustomExpressions: implementCustomExpressions,
    createRecipe: createRecipe,
    attachComponent: attachComponent,
    admin: {
        model: AdminModel,
        enhancedModel: AdminEnhancenModel,
        implementCustomInvariants: implementCustomAdminInvariants,
        implementCustomExpressions: implementAdminCustomExpressions,
        createRecipe: createAdminRecipe,
        attachComponent: attachAdminComponent
    }
};

//# sourceMappingURL=configurator-builder.js.map